import { magic } from '@gig/magic-sdk';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';

export function initConfirmationLimitsGuard(router: VueRouter) {
    router.beforeResolve(async (to, _, next) => {
        if (!(await shouldShowLimitsModal())) {
            return next();
        }

        if (to.name === RouteName.HOME) {
            return next();
        }

        if (isLimitsModalOpen()) {
            return next(
                new Error(
                    'Navigation canceled due to user block (grace period expired)',
                ),
            );
        }

        return next({
            name: RouteName.HOME,
        });
    });
}

async function shouldShowLimitsModal() {
    if (!magic.session.getUser()) {
        return false;
    }

    const isPepBlocked = await window.queryBus.query<boolean>(
        ACCOUNT_PEP_BLOCK_QUERY,
    );
    if (isPepBlocked) {
        return false;
    }

    const awaiting = await magic.invokeCached(
        60,
        magic.methods.responsibleGaming,
        'awaitingUserLimitsConfirmation',
    )();
    return awaiting.length > 0;
}

function isLimitsModalOpen() {
    return (
        document.getElementsByTagName('magic-limit-confirmation-prompt')
            .length != 0
    );
}
